type ResetHandler = () => void;

let resetHandlers: ResetHandler[] = [];

export const registerThoughtSpotAuthReset = (handler: ResetHandler): ResetHandler => {
  resetHandlers.push(handler);
  return () => {
    resetHandlers = resetHandlers.filter((h) => h !== handler);
  };
};

export const resetThoughtSpotAuth = (): void => {
  resetHandlers.forEach((handler) => handler());
};

export const __resetThoughtSpotAuthResetForTests = (): void => {
  resetHandlers = [];
};
